// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0dd7b20f","453":"273356f6","455":"606a3f9d","977":"bda262c0"}[chunkId] + ".chunk.js";
};